export const GET_CALENDAR_ENTRIES_LIST = 'APT/get_calendar_entries_list';
export const CREATE_CALENDAR_ENTRIES = 'APT/create_calendar_entries';
export const UPDATE_CALENDAR_ENTRIES = 'APT/update_calendar_entries';
export const SHOW_CALENDAR_ENTRIES = 'APT/show_calendar_entries';
export const DELETE_CALENDAR_ENTRIES = 'APT/delete_calendar_entries';

export const GET_ROLE_LIST = 'APT/get_role_list';

